// MobileStickyCTA — sticky bottom call-to-action shown on public marketing
// pages on mobile only. Single primary action: "Rezervă acum" deep-linking
// into the booking flow.
//
// Hidden on:
//   - Desktop (md+ breakpoint)
//   - When already on the booking flow (avoid the bar over its own steps)
//   - Inside authenticated portals (those have their own primary actions)
//
// Mounts inside <PublicLayout>. We rely on Tailwind's `md:hidden` for the
// breakpoint check and on the route shape passed in.

import { Link, useLocation } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '@/context/LanguageContext'
import { ROUTE_MAP } from '@/i18n/routes'

export default function MobileStickyCTA() {
  const { lang } = useLanguage()
  const { pathname } = useLocation()
  const { t } = useTranslation('home')

  // Don't double-stack on the booking flow itself.
  const bookingPaths = [ROUTE_MAP.booking.ro, ROUTE_MAP.booking.en]
  if (bookingPaths.some((p) => pathname.startsWith(p))) return null

  const target = ROUTE_MAP.booking[lang]
  const label = t('hero.bookNow', { defaultValue: 'Rezervă acum' })

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden pointer-events-none safe-bottom"
    >
      <div className="px-4 pb-3 pt-6 bg-gradient-to-t from-white via-white/95 to-transparent pointer-events-auto">
        <Link
          to={target}
          className="flex items-center justify-center gap-2 w-full bg-blue-600 active:bg-blue-700 active:scale-[0.99] transition text-white text-base font-semibold py-3.5 rounded-2xl shadow-lg shadow-blue-600/20"
        >
          <Sparkles className="h-5 w-5" />
          {label}
        </Link>
      </div>
    </div>
  )
}
